import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input, TemplateRef } from '@angular/core';
import { DatalistItemTitleDirective } from './datalist-item-title.directive';

@Component({
  selector: 'mri-datalist-item-header',
  standalone: true,
  template: `
    @if (hasCustomTitleTemplate) {
      <ng-container [ngTemplateOutlet]="customTitleTemplate"></ng-container>
    } @else {
      <span mriDatalistTitle title="{{ titleTooltip ?? '' }}">
        {{ title }}
      </span>
    }
    @if (subtitle) {
      <span class="mri-datalist__item-subtitle mri-datalist__item-truncated-text" title="{{ subtitleTooltip ?? '' }}">{{
        subtitle
      }}</span>
    }
  `,
  styles: [
    `
      .mri-datalist__item-subtitle {
        color: var(--mri-color-text-datalist-item-subtitle, inherit);
      }
    `
  ],
  imports: [NgTemplateOutlet, DatalistItemTitleDirective],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatalistItemHeaderComponent {
  @Input() title: string | undefined;
  @Input() titleTooltip: string | undefined;

  @Input() subtitle: string | undefined;
  @Input() subtitleTooltip: string | undefined;

  customTitleTemplate?: TemplateRef<HTMLElement>;

  get hasCustomTitleTemplate(): boolean {
    return !!this.customTitleTemplate;
  }

  @HostBinding('class.mri-datalist__item-header') readonly hostClass = true;
}
